import { cloneDeep } from 'lodash'
import {
    allReportNamesOptions,
    allReportTypesOptions,
    allClassificationTypesOptions,
    allDataSourcesOptions,
    allMutuallyRedeemingOptions,
    allMutuallyRedeemingLevelOptions,
    allMeasureUnitsOptions,
    allStatusOptions,
    allBudgetTypesOptions,
} from '../../common/baseOptions'
import { ReportOwnIncomeFilterSettings } from './settings/ReportOwnIncomeFilterSettings'
import { ReportOwnIncomeFilterOptions } from './options/ReportOwnIncomeFilterOptions'
import { Template } from '../../common/types/Template'
import { Option } from '../../common/types/Option'

// КАТ по доходам — все активные (type=1, end_date > NOW())
export const ownIncomeKatOptions: Option<number>[] = [
    { value: 1, label: '1 - Налоговые поступления',                              labelKk: '1 - Салықтық түсімдер' },
    { value: 2, label: '2 - Неналоговые поступления',                            labelKk: '2 - Салықтық емес түсімдер' },
    { value: 3, label: '3 - Поступления от продажи основного капитала',          labelKk: '3 - Негізгі капиталды сатудан түсімдер' },
    { value: 4, label: '4 - Специальные поступления',                            labelKk: '4 - Арнайы түсімдер' },
    { value: 5, label: '5 - Поступления трансфертов',                            labelKk: '5 - Трансферттер түсімдері' },
    { value: 6, label: '6 - Погашение бюджетных кредитов',                      labelKk: '6 - Бюджеттік кредиттерді өтеу' },
    { value: 7, label: '7 - Поступления от продажи финансовых активов государства', labelKk: '7 - Мемлекеттің қаржы активтерін сатудан түсімдер' },
    { value: 8, label: '8 - Поступления займов',                                 labelKk: '8 - Қарыздар түсімдері' },
    { value: 9, label: '9 - Используемые остатки бюджетных средств',             labelKk: '9 - Бюджет қаражатының пайдаланылатын қалдықтары' },
]

// КАТ, выбранные по умолчанию (1-4, без трансфертов и прочих)
export const ownIncomeKatDefaults = [1, 2, 3, 4]

// Временная затычка (используется при создании нового шаблона)
const tempSettings: ReportOwnIncomeFilterSettings = {
    // Base:
    reportName: 'OWN-INCOME',
    reportType: 'REGULATED',
    classificationType: 'INCOMES',
    dataSource: 'IISK',
    // Custom:
    measureUnit: 'THOUSAND',
    roundUpTo: null,
    date: '',
    regions: [],
    vzk: 'WITHOUT',
    statuses: ['39'],
    budgetTypes: [],
    mutuallyRedeemingLevels: [],
    kat_filter: null,
}

export const reportOwnIncomeBaseTemplate: Template = {
    id: null,
    name: 'Информация по собственным доходам на дату',
    excelName: null,
    description: null,
    category: '100',
    regions: [],
    userId: '',
    filterSettings: tempSettings,
}

export const reportOwnIncomeFilterOptions: ReportOwnIncomeFilterOptions = {
    // Base:
    key: 'OWN-INCOME',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => it.value !== 'MIXED')),
    // Custom:
    regions: [], // Загружается с бэка
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    statuses: cloneDeep(allStatusOptions),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    katOptions: cloneDeep(ownIncomeKatOptions),
}
